<script>
export default {
  name: 'MenuItem',
  functional: true,
  props: {
    icon: {
      type: String,
      default: ''
    },
    tip: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    }
  },
  render(h, context) {
    const { icon, tip, title } = context.props
    const vnodes = []

    if (icon) {
      vnodes.push(<svg-icon icon-class={icon} />)
    }

    if (title) {
      vnodes.push(<span slot='title'>{(title)}</span>)
    }

    if (tip) {
      vnodes.push(<i style='color:red;' class='el-icon-bell'></i>)
    }

    return vnodes
  }
}
</script>
